
import { reactive, computed, defineComponent } from 'vue'
import HeadingLv3 from '@/components/elements/HeadingLv3.vue'
import HospitalLabel from '@/components/elements/HospitalLabel.vue'
import TextLink from '@/components/elements/TextLink.vue'
import LatterBlockCassetteProgram from '@/components/block/LatterBlockCassetteProgram.vue'
import { numberFormatAddComma } from '@/utils/commonMethods'

export default defineComponent({
  props: {
    detail: {
      type: Object,
      default: () => ({})
    }
  },

  components: {
    HeadingLv3,
    HospitalLabel,
    TextLink,
    LatterBlockCassetteProgram
  },

  setup(props) {
    const data = reactive({
      bedNum: props.detail.bed_num
        ? numberFormatAddComma(props.detail.bed_num) + '床'
        : '',
      doctorNum: props.detail.doctor_num
        ? numberFormatAddComma(props.detail.doctor_num) + '人'
        : ''
    })

    const labels = computed(() => {
      const res = []
      if (props.detail?.prefectures) res.push(props.detail.prefectures)
      if (props.detail?.junior > 0) res.push('初期研修')
      if (props.detail?.specialist?.length) res.push('専門研修')
      return res
    })

    return {
      data,
      labels
    }
  }
})
